<template>
  <div id="app"></div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {};
  },
  created() {
    localStorage.removeItem("token");
    this.$router.push({ path: "login" });
  },
  mounted() {},
  methods: {},
};
</script>

<style>
</style>
